import { computed, ref } from 'vue';
import { type RouteLocationRaw, useRouter } from 'vue-router';
import { defineStore } from 'pinia';

export const useAppStore = defineStore('appStore', () => {
  const router = useRouter();

  const fading = ref(false);
  const isFading = computed(() => fading.value);
  const fadeDelay = 500;

  const beginFadeNavigation = (to: RouteLocationRaw) => {
    fading.value = true;

    setTimeout(async () => {
      router.push(to).then();
    }, fadeDelay);
  };

  const endFadeNavigation = () => {
    fading.value = false;
  };

  return {
    isFading,
    beginFadeNavigation,
    endFadeNavigation
  };
});
